import React from 'react';
import { 
    MdSmartToy,
    MdEmail,
    MdMovie,
    MdBusinessCenter,
    MdCameraAlt,
    MdBrush,
    MdAutoAwesome,
    MdRocketLaunch,
    MdGpsFixed,
    MdCampaign,
    MdVideocam,
    MdFavorite,
    MdLocationOn,
    MdCheckCircle,
    MdBarChart,
    MdPhoneAndroid
} from 'react-icons/md';

// Gradient color styles for icons
const gradientStyle = {
    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 50%, #f093fb 100%)',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    backgroundClip: 'text',
};

const gradientStyle2 = {
    background: 'linear-gradient(135deg, #f093fb 0%, #f5576c 50%, #4facfe 100%)',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    backgroundClip: 'text',
};

const gradientStyle3 = {
    background: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 50%, #43e97b 100%)',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    backgroundClip: 'text',
};

const gradientStyle4 = {
    background: 'linear-gradient(135deg, #fa709a 0%, #fee140 50%, #30cfd0 100%)',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    backgroundClip: 'text',
};

// Material Design filled icons with gradient colors
export const RobotIcon = ({ className = "w-12 h-12" }) => (
    <MdSmartToy className={className} style={gradientStyle} />
);

export const EnvelopeIcon = ({ className = "w-12 h-12" }) => (
    <MdEmail className={className} style={gradientStyle2} />
);

export const FilmIcon = ({ className = "w-12 h-12" }) => (
    <MdMovie className={className} style={gradientStyle3} />
);

export const BriefcaseIcon = ({ className = "w-12 h-12" }) => (
    <MdBusinessCenter className={className} style={gradientStyle4} />
);

export const CameraIcon = ({ className = "w-12 h-12" }) => (
    <MdCameraAlt className={className} style={gradientStyle} />
);

export const PaintBrushIcon = ({ className = "w-12 h-12" }) => (
    <MdBrush className={className} style={gradientStyle2} />
);

export const SparklesIcon = ({ className = "w-12 h-12" }) => (
    <MdAutoAwesome className={className} style={gradientStyle3} />
);

export const RocketLaunchIcon = ({ className = "w-12 h-12" }) => (
    <MdRocketLaunch className={className} style={gradientStyle4} />
);

export const TargetIcon = ({ className = "w-12 h-12" }) => (
    <MdGpsFixed className={className} style={gradientStyle} />
);

export const TheaterIcon = ({ className = "w-12 h-12" }) => (
    <MdMovie className={className} style={gradientStyle2} />
);

export const NewspaperIcon = ({ className = "w-12 h-12" }) => (
    <MdEmail className={className} style={gradientStyle3} />
);

export const HeartIcon = ({ className = "w-12 h-12" }) => (
    <MdFavorite className={className} style={gradientStyle4} />
);

export const MapPinIcon = ({ className = "w-12 h-12" }) => (
    <MdLocationOn className={className} style={gradientStyle} />
);

export const CheckBadgeIcon = ({ className = "w-12 h-12" }) => (
    <MdCheckCircle className={className} style={gradientStyle2} />
);

export const ChartBarIcon = ({ className = "w-12 h-12" }) => (
    <MdBarChart className={className} style={gradientStyle3} />
);

export const DevicePhoneMobileIcon = ({ className = "w-12 h-12" }) => (
    <MdPhoneAndroid className={className} style={gradientStyle4} />
);

// Use Cases Icons
export const BrandActivationIcon = ({ className = "w-12 h-12" }) => (
    <MdCampaign className={className} style={gradientStyle} />
);

export const CorporateGalaIcon = ({ className = "w-12 h-12" }) => (
    <MdVideocam className={className} style={gradientStyle2} />
);

export const TradeShowIcon = ({ className = "w-12 h-12" }) => (
    <MdCameraAlt className={className} style={gradientStyle3} />
);

export const WeddingPartyIcon = ({ className = "w-12 h-12" }) => (
    <MdFavorite className={className} style={gradientStyle4} />
);
